import { render, staticRenderFns } from "./AccessForm1.vue?vue&type=template&id=38e94fec&scoped=true"
import script from "./AccessForm1.vue?vue&type=script&lang=ts"
export * from "./AccessForm1.vue?vue&type=script&lang=ts"
import style0 from "./AccessForm1.vue?vue&type=style&index=0&id=38e94fec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e94fec",
  null
  
)

export default component.exports